import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { NEWS } from "@/data/content";
import { Reveal, SectionHead, EASE } from "./Reveal";

const NewsItem = ({ item, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: index * 0.05, ease: EASE }}
      data-testid={`news-item-${item.id}`}
      className="group relative border-t border-white/[0.08] transition-colors duration-500 hover:border-[rgba(94,177,255,0.4)]"
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-testid={`news-toggle-${item.id}`}
        className="grid w-full grid-cols-12 items-center gap-4 py-6 text-left md:gap-8"
      >
        <span className="col-span-2 font-mono text-2xl font-semibold text-white/15 transition-colors duration-500 group-hover:text-[var(--glow)] sm:text-3xl">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="col-span-8 font-display text-xl font-bold text-white sm:text-2xl md:col-span-7">
          {item.title}
        </span>
        <span className="col-span-2 flex items-center justify-end gap-4 md:col-span-3">
          <time className="hidden font-mono text-xs tracking-wider text-white/40 md:inline">{item.date}</time>
          <ChevronDown className={`h-5 w-5 shrink-0 text-white/50 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: EASE }}
            className="overflow-hidden"
          >
            <div className="grid grid-cols-12 gap-4 pb-8 md:gap-8">
              <div className="col-span-12 md:col-span-7 md:col-start-3">
                <time className="mb-3 block font-mono text-xs tracking-wider text-white/40 md:hidden">{item.date}</time>
                <p className="max-w-2xl text-sm leading-relaxed text-white/55 sm:text-base">{item.text}</p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.article>
  );
};

export const News = () => (
  <section id="hirek" className="relative py-28 sm:py-36" data-testid="news-section">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <SectionHead eyebrow="Hírek" title={NEWS.eyebrow} testId="news-head" />
      <Reveal delay={0.15} className="mt-16 border-b border-white/[0.08]">
        {NEWS.items.map((item, i) => <NewsItem key={item.id} item={item} index={i} />)}
      </Reveal>
    </div>
  </section>
);
